<template>
  <v-dialog
    :value="value"
    @input="(e) => $emit('input', e)"
    width="400"
    content-class="tw-m-0"
  >
    <v-card>
      <v-card-title>{{ $t("unsavedChanges.title") }}</v-card-title>
      <v-card-text>
        <div>{{ $t("unsavedChanges.leaveQuestion") }}</div>
        <div>{{ $t("unsavedChanges.notSaved") }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)" class="tw-text-green"
          >{{ $t("common.cancel") }}</v-btn
        >
        <v-btn text @click="$emit('leave')">{{
          $t("unsavedChanges.leave")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UnsavedChangesDialog",

  props: {
    value: { type: Boolean, required: true },
  },
}
</script>
